<template>
  <section>
    <div class="card">
      <div class="card-header">{{ $t('message.menu.my_listings') }}</div>
      <div class="card-body">
        <router-link to="/user/listings/add"
                     class="btn btn-info px-4">
          <i class="far fa-plus"></i>
          {{ $t('message.my_listings.add_new_listing') }}
        </router-link>
        <div class="table-responsive mt-4" v-if="listings.length > 0">
          <table class="table">
            <thead>
            <tr class="d-flex">
              <th class="col-3">{{ $t('message.my_listings.name') }}</th>
              <th class="col-3">{{ $t('message.my_listings.type') }}</th>
              <th class="col-4">{{ $t('message.my_listings.address') }}</th>
              <th class="col-2">&nbsp;</th>
            </tr>
            </thead>
            <tbody>
            <tr class="d-flex" v-for="listing, index in listings" :key="index">
              <td class="col-3">
                {{ listing.place_name }}
              </td>
              <td class="col-3">{{ $t(globalState.placeSizes[listing.place_size_id]) | multiLangName }}</td>
              <td class="col-4">
                <p>{{ globalState.cities[listing.province_id] | multiLangName }}</p>
                <p>{{ listing.address }}</p>
              </td>
              <td class="col-2">
                <p>
                  <router-link
                    class="text-primary-link"
                    :to="'/user/listings/'+listing.id+'/edit'">
                    {{ $t('message.my_listings.edit') }}
                  </router-link>
                </p>
                <p>
                  <a href="#"
                     class="text-primary-link"
                     @click.prevent="deleteListing(index, listing.id)">
                    {{ $t('message.my_listings.delete') }}
                  </a>
                </p>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-center">
          <button class="button -cyan"
                  :disabled="state.isFetching"
                  @click.prevent="fetchListings"
                  v-if="state.isMore"> {{ $t(isLoadMore) }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        queryData: {
          page: 0,
          user_id: null
        }
      }
    },
    computed: {
      ...mapGetters({
        isLoadMore: 'listing/isLoadMore',
        globalState: 'globalVal/getState',
        listings: 'listing/getListings',
        state: 'listing/getState',
        user: 'auth/getUser'
      })
    },
    methods: {
      fetchListings () {
        this.queryData.page++
        this.$store.dispatch('listing/LOAD_LISTING_LIST', this.queryData)
      },
      deleteListing (index, id) {
        this.$swal({
          title: this.$i18n.t('message.confirm.title'),
          text: this.$i18n.t('message.confirm.remove_list'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#9E9E9E',
          reverseButtons: true,
          confirmButtonText: this.$i18n.t('message.confirm.yes'),
          cancelButtonText: this.$i18n.t('message.confirm.cancel')
        }).then(() => {
          this.$store.commit('listing/SET_SELECTED_INDEX', index)
          this.$store.dispatch('listing/DELETE_LISTING', id)
        })
      }
    },
    mounted () {
      this.queryData.user_id = this.user.id
      this.$store.dispatch('listing/LOAD_LISTING_LIST', this.queryData)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/listing/Index.vue